export default class EventService {
    /* @ngInject */
    constructor(apiService) {
        this.apiService = apiService;
    }

    create(teamId, calendar) {
        return this.apiService.post(`/teams/${teamId}/calendars`, calendar).then((result) => result.data);
    }

    update(calendar) {
        return this.apiService.put(`/calendars/${calendar.id}`, {
            name: calendar.name,
            useAutoForecasting: !!calendar.useAutoForecasting,
            color: calendar.color || null,
            note: calendar.note || null,
            accounts: (calendar.accounts || []).map((account) => ({
                name: account.name
            }))
        }).then((result) => result.data);
    }

    remove(calendar) {
        return this.apiService.delete(`/calendars/${calendar.id}`).then((result) => result.data);
    }

    reorder(teamId, ids) {
        return this.apiService.post(`/teams/${teamId}/calendars/order`, ids).then((result) => result.data);
    }

    markAsDefault(calendar) {
        return this.apiService.patch(`/calendars/${calendar.id}`, [
            {
                path: 'isDefault',
                value: true
            }
        ]).then((result) => result.data);
    }
}



// WEBPACK FOOTER //
// ./src/application/service/calendar/calendar.service.js